import { render, staticRenderFns } from "./UsersEdit.vue?vue&type=template&id=f8b0a2d4&scoped=true&"
import script from "./UsersEdit.vue?vue&type=script&lang=js&"
export * from "./UsersEdit.vue?vue&type=script&lang=js&"
import style0 from "./UsersEdit.vue?vue&type=style&index=0&id=f8b0a2d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b0a2d4",
  null
  
)

export default component.exports